module.exports = __webpack_public_path__ + "img/olive-branch.bd19dac4.svg";